import React from "react";

const ViewContentModal = ({ blog, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div
                className="bg-white rounded-lg w-full max-w-2xl p-6"
                style={{ maxHeight: "90vh", overflowY: "auto" }}
            >
                <h2 className="text-xl font-bold mb-4">{blog.title}</h2>
                <div className="mb-4">
                    <h3 className="font-semibold mb-1">Short Description</h3>
                    <div dangerouslySetInnerHTML={{ __html: blog.shortDescription }} />
                </div>
                <div className="mb-4">
                    <h3 className="font-semibold mb-1">Description</h3>
                    <div dangerouslySetInnerHTML={{ __html: blog.description }} />
                </div>
                <div className="flex justify-end">
                    <button onClick={onClose} className="px-4 py-2 bg-primary-600 text-white rounded">Close</button>
                </div>
            </div>
        </div>
    );
};

export default ViewContentModal;